// import React, { useCallback, useEffect, useState } from "react";
import Layout1 from "../../DataLayouts/Layout1";
import NextWeekIcon from "@mui/icons-material/NextWeek";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import React, { useCallback, useEffect, useState, useRef } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InboxIcon from "@mui/icons-material/Inbox";

import axios from "axios";
import toast from "react-hot-toast";
import { MAIN_URL } from "../../../Configurations/Urls";
import { fetchWorkBreaks } from "../../../Apis/Workshift-api";
import TableDataGeneric from "../../../Configurations/TableDataGeneric";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Layout4 from "../../DataLayouts/Layout4";
import { fetchPayrollAdvances, fetchPayrollComponents } from "../../../Apis/Payroll";




import { operatorRequiresValue } from "../../../Components/filters/operators";

const DEFAULT_PAGINATION = {
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 1,
  hasNext: false,
  hasPrev: false,
};

const DEFAULT_URL_PARAMS = {
  page: "1",
  pageSize: "10",
  sortBy: "status",
  sortOrder: "desc",
};

// Helper function to build filters from URL search parameters
const buildFiltersFromParams = (searchParams) => {
  const filters = [];
  const processedFields = new Set();

  searchParams.forEach((value, key) => {
    if (
      key.endsWith("_operator") ||
      key.endsWith("_logic") ||
      !key.startsWith("filter_")
    )
      return;

    const field = key.replace("filter_", "");
    if (processedFields.has(field)) return;
    processedFields.add(field);

    const operator = searchParams.get(`filter_${field}_operator`) || "contains";
    const requiresValue = operatorRequiresValue(operator);

    if (!requiresValue || value) {
      let filterValue = requiresValue ? value : null;

      if (requiresValue && filterValue) {
        if (["equals", "not_equals"].includes(operator)) {
          filterValue = filterValue
            .split(",")
            .map((v) => v.trim().toLowerCase());
        } else if (["between", "not_between"].includes(operator)) {
          filterValue = filterValue.split(",").map((v) => v.trim());
        }
      }

      filters.push({ field, operator, value: filterValue });
    }
  });

  // Handle search parameter
  const search = searchParams.get("search");
  if (search) {
    filters.push({
      field: "status",
      operator: "contains",
      value: search,
    });
  }

  return filters;
};





function AdvancePayrollList() {
  const [loading, setLoading] = useState(true);
  const [Break, setBreak] = useState([]);
  const { userData } = useAuthStore();
  const org = userData?.organization;
  const navigate = useNavigate();

  const [paginationData, setPaginationData] = useState(DEFAULT_PAGINATION);
  const [searchParams, setSearchParams] = useSearchParams();
  const fetchControllerRef = useRef(null);
  const hasInitializedURL = useRef(false);

  const { id } = useParams();

  // useEffect(() => {
  //   if (org?.organization_id) {
  //     setLoading(true);
  //     fetchPayrollAdvances(org?.organization_id)
  //       .then((data) => {
  //         let a = data?.payrollAdvances;
  //         console.log("break", a);
  //         let b = a.map((item) => {
  //           return {
  //             ...item,
  //             id: item?.organization_payroll_advance_id,
  //               employee_code:item?.organization_person?.person_code,
  //              employee_name: item?.organization_person
  //               ? `${item.organization_person?.person.first_name || ""}  ${item.organization_person?.person?.middle_name || ""} ${item.organization_person?.person?.last_name || ""}`
  //               : "",
  //           };
  //         });
  //         setBreak(b);
  //       })
  //       .catch((err) => {});
  //     setLoading(false);
  //   }
  // }, [org]);


  // Initialize URL params ONCE
useEffect(() => {
  if (hasInitializedURL.current) return;

  const params = new URLSearchParams(searchParams);
  let needsUpdate = false;

  Object.entries(DEFAULT_URL_PARAMS).forEach(([key, defaultValue]) => {
    if (!params.has(key)) {
      params.set(key, defaultValue);
      needsUpdate = true;
    }
  });

  if (needsUpdate) {
    setSearchParams(params, { replace: true });
  }

  hasInitializedURL.current = true;
}, [searchParams, setSearchParams]);

// Fetch payroll advances with filters
useEffect(() => {
  if (!org?.organization_id || !hasInitializedURL.current) return;

  fetchControllerRef.current?.abort();
  fetchControllerRef.current = new AbortController();

  setLoading(true);

  const fetchData = async () => {
    try {
      const filters = buildFiltersFromParams(searchParams);

      const requestBody = {
        filters,
        page: Number.parseInt(searchParams.get("page"), 10) || 1,
        pageSize: Number.parseInt(searchParams.get("pageSize"), 10) || 10,
        sort: {
          field: searchParams.get("sortBy") || "organization_payroll_advance_id",
          direction: searchParams.get("sortOrder") || "desc",
        },
      };

      const response = await fetch(
        `${MAIN_URL}/api/organizations/${org.organization_id}/payroll-advance/filtered`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
          signal: fetchControllerRef.current.signal,
        }
      );

      let data = [];

      if (response.ok) {
        const result = await response.json();

        if (result.success && result.data) {
          data = result.data;

          if (result.pagination) {
            setPaginationData({
              page: result.pagination.page || 1,
              pageSize: result.pagination.pageSize || 10,
              total: result.pagination.total || 0,
              totalPages: result.pagination.totalPages || 1,
              hasNext: result.pagination.hasNext || false,
              hasPrev: result.pagination.hasPrev || false,
            });
          }
        } else {
          setPaginationData(DEFAULT_PAGINATION);
        }
      } else if (response.status === 404) {
        const oldData = await fetchPayrollAdvances(org.organization_id);
        data = oldData?.payrollAdvances || [];
        setPaginationData(DEFAULT_PAGINATION);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const formatted = data.map((item) => ({
        ...item,
        id: item?.organization_payroll_advance_id,
        // employee_code: item?.organization_person?.person_code || "",
        // employee_name: item?.organization_person
        //   ? `${item.organization_person?.person?.first_name || ""} ${
        //       item.organization_person?.person?.middle_name || ""
        //     } ${item.organization_person?.person?.last_name || ""}`
        //   : "",
      }));

      setBreak(formatted);
    } catch (err) {
      if (err.name === "AbortError") return;

      console.error("Failed to fetch payroll advances:", err);
      toast.error("Failed to fetch payroll advances");
      setBreak([]);
      setPaginationData(DEFAULT_PAGINATION);
    } finally {
      setLoading(false);
    }
  };

  fetchData();

  return () => {
    fetchControllerRef.current?.abort();
  };
}, [org, searchParams]);

// Sort handler
const handleSortChange = useCallback(
  (newSortBy, newSortOrder) => {
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        params.set("sortBy", newSortBy);
        params.set("sortOrder", newSortOrder);
        params.set("page", "1");
        return params;
      },
      { replace: true }
    );
  },
  [setSearchParams]
);

  

  let deleteBreak = async (id) => {
    try {
      const org_id = org.organization_id;
      const response = await axios.delete(
        `${MAIN_URL}/api/organizations/${org_id}/payroll-advance/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          validateStatus: function (status) {
            return status >= 200 && status < 500;
          },
        }
      );

      if (response.status === 200) {
        toast.success(response.data.message);
        console.log("Break:", response.data.message);
      } else {
        const errorMessage =
          response.data.message ||
          response.data.errors?.[Object.keys(response.data.errors)[0]]?.[0] ||
          "Break";

        toast.error(errorMessage);
        console.warn("Deletion error:", response.status, response.data);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session Expired!");
        window.location.href = "/login";
      }
      console.error("Delete failed:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };

  const handleEdit = useCallback(
    (item) => {
      navigate(`/payroll/advance/edit/${item.id}`);
    },

    [navigate]
  );

  return (
    <>
      <Layout4
        loading={loading}
        heading={"Advance Payroll"}
        btnName={"Add Advance"}
        add_action={"PAYROLL_ADVANCE_ADD"}
        Data={Break}
        delete_action={"ORG_STRUCTURE_DELETE"}
        tableHeaders={[
          {
            name: "Attendance Break",
            value_key: "breaktype",
            textStyle: "capitalize",
          },
          {
            name: "Workshift",
            value_key: "workshift",
            textStyle: "capitalize",
          },
        ]}
        Icons={[
          <LocalPoliceIcon sx={{ fontSize: 60, color: "grey.500", mb: 2 }} />,
          <NextWeekIcon color="primary" />,
          <LocalPoliceIcon sx={{ color: "text.secondary" }} />,
        ]}
        messages={[
          "Advance Payroll",
          "Advance Payroll",
          "Add Advance Payroll",
          "Advance Payroll, Deleting this Payroll will also remove all related employees",
        ]}
        Route={"/payroll/advance"}
        setData={setBreak}
        DeleteFunc={deleteBreak}
      />

{
  Break.length === 0 && !loading ? (
    <EmptyState/>
  ) : (
    <TableDataGeneric
    tableName="organization_payroll_advances"
    primaryKey="organization_payroll_advance_id"
    heading="Advance Payrolls"
    filterModule="organization_payroll_advances"
    data={Break}
    sortname={"status"}
    showActions={true}
    Route="/payroll/advance"
    edit_delete_action={["PAYROLL_ADVANCE_DELETE", "PAYROLL_ADVANCE_EDIT"]}
    DeleteFunc={deleteBreak}
    EditFunc={handleEdit}
    token={localStorage.getItem("token")}
  />

  )
}
    </>
  );
}

const EmptyState = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "300px",
      textAlign: "center",
      color: "text.secondary",
    }}
  >
    <InboxIcon sx={{ fontSize: 80, color: "grey.400", mb: 2 }} />
    <Typography variant="h6" gutterBottom>
      No Payroll Advances Found
    </Typography>
    <Typography variant="body2">
      {window.location.search ? "Try adjusting your filters." : "Add new payroll Advances to get started."}
    </Typography>
  </Box>
);


export default AdvancePayrollList;
